<template>
  <div>
    <div class="row border-bottom">
      <div class="col-md-12 col text-center pb-8 pl-50 pr-50">
        <span v-if="currentDocument.docName == eulaAgrementDoc" v-translate:eula_document_name="lang">{{ currentDocument.docName }}</span>
        <span
          v-else
          class="global-activity-title"
          v-translate:dynamic_string="{
            key: (currentDocument.docName.toLowerCase() == 'datavant tokenization consent') ? 'datavant_consent_form_title' : `${currentDocument.consentId}_consentName`,
            val: lang,
            html: currentDocument.docName
          }"
          >{{ currentDocument.docName }}</span
        >
      </div>
    </div>
    <div class="user-info pt-10">
      <DocumentSigner v-if="currentDocument.status == 'RequestedSignature'" @backButtonClicked="goBackToList" @signingCompleted="onDocSigningCompleted" :document="currentDocument" />
      <DocumentViewer v-else-if="currentDocument" :documentUrl="currentDocument.preSignedUrl + '#toolbar=0'" @loading="documentLoading" />
      <!-- <iframe v-else-if="currentDocument" frameBorder="0" @load="documentLoaded" :src="currentDocument.preSignedUrl + '#toolbar=0'" style="width:100%; height:717px; border: none; background-color:#fff;" scrolling="no"></iframe> -->
      <div v-if="currentDocument.docName.toLowerCase().trim() == 'datavant tokenization consent' && currentDocument.status.toLowerCase() == 'declined'"></div>
      <div v-else-if="!isLoading && currentDocument.isParticipantSigned" class="signed-banner">      
        <h3>
          <span v-translate:agreed_to="lang">Agreed to on</span>
          {{ agreedOnDateTime }}
        </h3>
      </div>
    </div>
  </div>
</template>
<script>
import { Bitrise, Consent } from "@/components/services/participant-service";
import DocumentSigner from "./document-signer";
import nprogress from "nprogress";
import DocumentViewer from "./document-viewer";
import moment from "moment";

export default {
  name: "document-details",
  components: { DocumentSigner, DocumentViewer },
  props: ["document", "active", "eulaAgrementDoc"],
  data() {
    return {
      consent: new Consent(),
      bitrise: new Bitrise(),
      currentDocument: this.document,
      isLoading: false
    };
  },
  mounted() {
    this.document = this.currentDocument;
    if (this.currentDocument.status !== "RequestedSignature") {
      this.$root.$emit("SetBackButtonClickEvent", "show-document-list");
      this.$root.$on("show-document-list", this.goBackToList);
    }
  },
  beforeUnmount() {
    this.unbindCancelAndBack();
  },
  watch: {
    active(val) {
      if (!val) {
        this.unbindCancelAndBack();
      }
    }
  },
  computed: {
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    agreedOnDateTime() {
      return moment(this.currentDocument.participantSignDate).format("ll") + " at " + moment(this.currentDocument.participantSignDate).format("LT");
    }
  },
  methods: {
    documentLoading(evt) {
      if (evt) {
        nprogress.start();
        this.isLoading = true;
      } else {
        nprogress.done();
        this.isLoading = false;
      }
    },
    onDocSigningCompleted() {
      this.$emit("onDocCompleted", this.currentDocument);
    },
    unbindCancelAndBack() {
      this.$root.$on("SetBackButtonClickEvent", null);
      this.$root.$emit("SetCancelButtonVisibility", false);
    },
    goBackToList(evt) {
      this.$emit("backButtonClicked", evt);
    }
  }
};
</script>
<style scoped>
.vs-box-wrapper {
  height: 657px;
}
.signed-banner {
  background-color: #3d6384;
  color: white;
}
</style>
